export enum ROUTES {
    HOMEPAGE_ROUTE = '/',
    RECAPPAGE_ROUTE = '/recap',
    PRIVACY_ROUTE = '/privacy',
    APPOINTMENT_DETAIL = '/appointment-detail'
}

export enum ERRORS_MESSAGES {
    OPERATOR_NOT_AVAILABLE = 'operator not available',
    SLOT_ALREADY_TAKEN_FROM_USER = 'slot already reserved from user',
    TOKEN_INVALID = 'Authorization token invalid',
    RECAPTCHA_ERROR = 'reCaptchaValidationError',
    MAIL_FORMAT_NOT_VALID = '[PE1] Email is not valid',
}

export const mailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

export const gReCaptchaSiteKey = '6Lc4gdMdAAAAAMAlIeKBg9vI7xKg3nPwV9iVQfi4'